import { createSelector } from 'reselect'

export const getInsuranceCompanies = state => state.get('insuranceCompanies')

export const getAll = createSelector(
  getInsuranceCompanies,
  insuranceCompanies => insuranceCompanies.get('all'),
)

export const isAllFetched = createSelector(
  getInsuranceCompanies,
  insuranceCompanies => insuranceCompanies.get('isAllFetched'),
)

export const getDeferreds = createSelector(
  getInsuranceCompanies,
  insuranceCompanies => insuranceCompanies.get('deferreds'),
)
